// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__5V3YO","label":"CategoryService_label__928nQ","location":"CategoryService_location__10say"};